(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plymtree-food-preorder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pf-food-page]').forEach((page) => {
    if (page.dataset.pfFoodReady === 'true') return;
    page.dataset.pfFoodReady = 'true';

    const form = page.querySelector('[data-pf-food-form]');
    if (!form) return;
    const quantities = Array.from(page.querySelectorAll('[data-variant-id]'));
    const total = page.querySelector('[data-pf-food-total]');
    const error = page.querySelector('[data-pf-food-error]');
    const submit = form.querySelector('button[type="submit"]');
    const formatter = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });

    const setQuantity = (input, value) => {
      const quantity = Math.max(0, Math.floor(Number(value) || 0));
      input.value = String(quantity);
      input.closest('.pf-food-stepper').querySelector('[data-quantity-display]').textContent = String(quantity);
    };
    const updateTotal = () => {
      const amount = quantities.reduce((sum, input) => sum + (Number(input.value) || 0) * Number(input.dataset.price), 0);
      total.textContent = formatter.format(amount / 100);
    };

    quantities.forEach((input) => {
      const stepper = input.closest('.pf-food-stepper');
      stepper.querySelector('[data-quantity-decrease]').addEventListener('click', () => {
        setQuantity(input, Number(input.value) - 1);
        updateTotal();
      });
      stepper.querySelector('[data-quantity-increase]').addEventListener('click', () => {
        setQuantity(input, Number(input.value) + 1);
        updateTotal();
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      error.hidden = true;
      const items = quantities
        .map((input) => ({ id: Number(input.dataset.variantId), quantity: Number(input.value) || 0 }))
        .filter((item) => item.quantity > 0);

      if (items.length === 0) {
        error.textContent = 'Please choose at least one food item.';
        error.hidden = false;
        return;
      }

      submit.disabled = true;
      submit.textContent = 'Adding food…';
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Food could not be added. Please try again.');
        window.location.assign(`${root}cart`);
      } catch (requestError) {
        error.textContent = requestError.message;
        error.hidden = false;
        submit.disabled = false;
        submit.textContent = 'Add food to basket';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plymtree-ticket-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pf-ticket-page]').forEach((page) => {
    if (page.dataset.pfTicketReady === 'true') return;
    page.dataset.pfTicketReady = 'true';

    const form = page.querySelector('[data-pf-ticket-form]');
    const quantities = Array.from(page.querySelectorAll('[data-variant-id]'));
    const total = page.querySelector('[data-pf-ticket-total]');
    const error = page.querySelector('[data-pf-ticket-error]');
    const submit = form.querySelector('button[type="submit"]');
    const formatter = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });

    const updateTotal = () => {
      const amount = quantities.reduce((sum, input) => sum + (Number(input.value) || 0) * Number(input.dataset.price), 0);
      total.textContent = formatter.format(amount / 100);
    };
    const setQuantity = (input, value) => {
      const quantity = Math.max(0, Math.floor(Number(value) || 0));
      input.value = String(quantity);
      input.closest('.pf-ticket-stepper').querySelector('[data-quantity-display]').textContent = String(quantity);
    };

    quantities.forEach((input) => {
      const stepper = input.closest('.pf-ticket-stepper');
      stepper.querySelector('[data-quantity-decrease]').addEventListener('click', () => {
        setQuantity(input, Number(input.value) - 1);
        updateTotal();
      });
      stepper.querySelector('[data-quantity-increase]').addEventListener('click', () => {
        setQuantity(input, Number(input.value) + 1);
        updateTotal();
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      error.hidden = true;
      const items = quantities
        .map((input) => ({ id: Number(input.dataset.variantId), quantity: Number(input.value) || 0 }))
        .filter((item) => item.quantity > 0);

      if (items.length === 0) {
        error.textContent = 'Please choose at least one ticket.';
        error.hidden = false;
        return;
      }

      submit.disabled = true;
      submit.textContent = 'Adding tickets…';

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Tickets could not be added. Please try again.');
        window.location.assign(`${root}cart`);
      } catch (requestError) {
        error.textContent = requestError.message;
        error.hidden = false;
        submit.disabled = false;
        submit.textContent = 'Add tickets to basket';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
